import { Icon, Space, SubText, WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type ColumnTypeData } from '../../types/DataTable.types'

// Remove this when AP_10171_AP_INLINE_EDITS is removed
export const APItemAccountCodeCell = ({
  accountCode,
  hasMultipleCostAllocations = false,
  exception = null,
}: ColumnTypeData['AP_ITEM_ACCOUNT_CODE']) => {
  const intl = useProcurifyIntl()

  if (hasMultipleCostAllocations) {
    return <SubText>{intl.formatMessage(messages.multipleAccountText)}</SubText>
  } else if (exception) {
    return (
      <WithTooltip
        title={intl.formatMessage(messages.missingCostAllocationMessage)}
        placement='top'
      >
        <WithTooltip.Wrapper>
          <Space
            direction='horizontal'
            align='center'
            justify='start'
            size='small'
          >
            <Icon
              icon='close'
              size={16}
              color='danger'
              ariaLabel={intl.formatMessage(
                messages.missingCostAllocationWarningIconAriaLabel
              )}
            />
            <SubText>{'--'}</SubText>
          </Space>
        </WithTooltip.Wrapper>
      </WithTooltip>
    )
  } else {
    return <SubText>{accountCode}</SubText>
  }
}
